import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useParams,
} from "react-router-dom";

import Home from "./pages/home/home";
import PrivacyPolicy from "./pages/privacyPolicy";
import PrivacyPolicyPlaneGame from "./pages/privacyPolicyPlaneGame";
import PrivacyPolicyPMathPuzzles from "./pages/privacyPolicyMathPuzzles";
import AdsTxt from "./AdsTxt";
import TermsOfUse from "./pages/termsOfUse";
import PrivacyPolicyTracktorGps from "./pages/privacyPolicyTracktorGps";
import TermsOfUseTractorGps from "./pages/termsOfUseTractorGps";
import TermsOfUseLocation from "./pages/terms-of-use";
import PrivacyPolicyLocation from "./pages/privacy-policy";
import PrivacyPolicyBasketballTraining from "./pages/privacyPolicyBasketballTraining";
import TermsOfUseBasketballTraining from "./pages/termsOfUseBasketballTraining";
import PrivacyPolicyV2 from "./pages/v2/privacypolicy";
import TermsOfUseV2 from "./pages/v2/termsofuse";
import PrivacyPolicyHairTryOn from "./pages/hairtryon/privacypolicy";
import TermsOfUseHairTryOn from "./pages/hairtryon/termsofuse";
import PrivacyPolicyBeardMustacheFilter from "./pages/beardmustachefilter/privacypolicy";
import TermsOfUseBeardMustacheFilter from "./pages/beardmustachefilter/termsofuse";
import PrivacyPolicyCarModify from "./pages/carmodify/privacypolicy";
import TermsOfUseCarModify from "./pages/carmodify/termsofuse";
import PrivacyPolicyAiColorAnalysis from "./pages/aicoloranalysis/privacypolicy";
import TermsOfUseAiColorAnalysis from "./pages/aicoloranalysis/termsofuse";
import PrivacyPolicyAiInterior from "./pages/aiinterior/privacypolicy";
import TermsOfUseAiInterior from "./pages/aiinterior/termsofuse";
import PrivacyPolicyAiScaleForGrams from "./pages/aiscaleforgrams/privacypolicy";
import TermsOfUseAiScaleForGrams from "./pages/aiscaleforgrams/termsofuse";

const LEGACY_PRIVACY_REDIRECTS = {
  "AI Clothes Changer": "/v2/privacypolicy/AI%20Clothes%20Changer",
  "Car Modify": "/carmodify/privacypolicy",
  "Beard & Mustache Filter": "/beardmustachefilter/privacypolicy",
  "AI Style Changer": "/hairtryon/privacypolicy",
};

function LegacyPrivacyPolicy() {
  const { id } = useParams();
  let name = id || "";
  try {
    name = decodeURIComponent(name);
  } catch (error) {
    name = id || "";
  }

  const target = LEGACY_PRIVACY_REDIRECTS[name];
  if (target) {
    return <Navigate to={target} replace />;
  }

  return <PrivacyPolicy />;
}

export default function App() {
  return (
    <Router>
      <div className="body">
        <Routes>
          <Route path="/app-ads.txt" element={<AdsTxt />} />
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/privacypolicy/:id" element={<LegacyPrivacyPolicy />} />
          <Route
            path="/privacypolicyTracktorGps"
            element={<PrivacyPolicyTracktorGps />}
          />
          <Route path="/termsOfUse/:id" element={<TermsOfUse />} />
          <Route
            path="/termsOfUseTractorGps"
            element={<TermsOfUseTractorGps />}
          />
          <Route
            path="/privacypolicyPlaneGame"
            element={<PrivacyPolicyPlaneGame />}
          />
          <Route
            path="/privacyPolicyMathPuzzles"
            element={<PrivacyPolicyPMathPuzzles />}
          />
          <Route
            path="/privacypolicyBasketballTraining"
            element={<PrivacyPolicyBasketballTraining />}
          />
          <Route
            path="/termsOfUseBasketballTraining"
            element={<TermsOfUseBasketballTraining />}
          />

          <Route path="/terms-of-use/:id" element={<TermsOfUseLocation />} />
          <Route
            path="/privacy-policy/:id"
            element={<PrivacyPolicyLocation />}
          />

          <Route path="/v2/privacypolicy/:id" element={<PrivacyPolicyV2 />} />
          <Route path="/v2/termsofuse/:id" element={<TermsOfUseV2 />} />

          <Route
            path="/hairtryon/privacypolicy"
            element={<PrivacyPolicyHairTryOn />}
          />
          <Route
            path="/hairtryon/termsofuse"
            element={<TermsOfUseHairTryOn />}
          />

          <Route
            path="/beardmustachefilter/privacypolicy"
            element={<PrivacyPolicyBeardMustacheFilter />}
          />
          <Route
            path="/beardmustachefilter/termsofuse"
            element={<TermsOfUseBeardMustacheFilter />}
          />

          <Route
            path="/carmodify/privacypolicy"
            element={<PrivacyPolicyCarModify />}
          />
          <Route
            path="/carmodify/termsofuse"
            element={<TermsOfUseCarModify />}
          />

          <Route
            path="/aicoloranalysis/privacypolicy"
            element={<PrivacyPolicyAiColorAnalysis />}
          />
          <Route
            path="/aicoloranalysis/termsofuse"
            element={<TermsOfUseAiColorAnalysis />}
          />

          <Route
            path="/aiinterior/privacypolicy"
            element={<PrivacyPolicyAiInterior />}
          />
          <Route
            path="/aiinterior/termsofuse"
            element={<TermsOfUseAiInterior />}
          />

          <Route
            path="/aiscaleforgrams/privacypolicy"
            element={<PrivacyPolicyAiScaleForGrams />}
          />
          <Route
            path="/aiscaleforgrams/termsofuse"
            element={<TermsOfUseAiScaleForGrams />}
          />
        </Routes>
      </div>
    </Router>
  );
}
